export function returnSaleReducer(state = "",{
    type,
    payload
}){
    switch(type){
        
        case "GET_RETURN_SALES":
            return payload
        case "NEW_RETURN_SALE":
            return {
                ...state,
                [payload.id]: payload
            }
        case "DELETE_RETURN_SALE":
            const { [payload]: deleted, ...newState } = state;
            return newState;
        default:
            return state;
    }
    
}